module.exports = __webpack_public_path__ + "img/idcard_camera.3b323c22.png";